module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-FC-Combined.8a21f218.gif";